import { render, staticRenderFns } from "./update-appointment-details-modal.html?vue&type=template&id=608a4157&scoped=true&external"
import script from "./update-appointment-details-modal.js?vue&type=script&lang=js&external"
export * from "./update-appointment-details-modal.js?vue&type=script&lang=js&external"
import style0 from "./update-appointment-details-modal.scss?vue&type=style&index=0&id=608a4157&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608a4157",
  null
  
)

export default component.exports